import { ApolloProvider } from "@apollo/client";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";

import { initApolloClient } from "./client";

type ApolloContextProps = {
  notifyBugsnag?: (error: string) => void;
  children: React.ReactNode;
};

const ApolloContext = ({ notifyBugsnag, children }: ApolloContextProps) => {
  const { onError } = useTypedContext(FlashContext);

  const client = initApolloClient(onError, notifyBugsnag);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloContext;
